import { Box } from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import { createStyles, withStyles, useTheme } from '@material-ui/styles';
import { alpha } from '@material-ui/core/styles';
import classNames from 'classnames';
import * as React from 'react';
import { compose, pure } from 'recompose';
import { Loader } from '@topconagriculture/loader';
const styles = (theme) => createStyles({
    modalContent: {
        fontSize: theme.font.size.medium,
        color: theme.color.font.dark,
        padding: 20,
        minHeight: 100,
    },
    contentLoading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 150,
        overflow: 'hidden',
    },
});
const ModalContent = (props) => {
    const { classes, children, className: classNameProp, isLoadingContent, showLoadingOverlay, testId = 'ModalContent', } = props;
    const theme = useTheme();
    const className = classNames(classes.modalContent, classNameProp, isLoadingContent && classes.contentLoading);
    return (React.createElement(DialogContent, { "data-testid": testId, className: className },
        showLoadingOverlay ? (React.createElement(Box, { position: "absolute", top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", bgcolor: alpha(theme.palette.background.paper, 0.5) },
            React.createElement(Loader, null))) : null,
        children));
};
const ComposedModalContent = compose(withStyles(styles, { withTheme: true }), pure)(ModalContent);
ComposedModalContent.displayName = 'ModalContent';
export default ComposedModalContent;
//# sourceMappingURL=ModalContent.js.map